module.exports = __webpack_public_path__ + "img/main_logo.bcab1ca0.png";